exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.bigDiv[data-v-013e7a48]{\n  font-size: 3em;\n  color: #2D80C7;\n}\n.normalDiv[data-v-013e7a48]{\n  font-size: 1.8em;\n  color: #2D80C7;\n}\n@media screen and (max-width: 981px) {\n.bigDiv[data-v-013e7a48]{\n    font-size: 6em;\n    color: #2D80C7;\n}\n.normalDiv[data-v-013e7a48]{\n    font-size: 4em;\n    color: #2D80C7;\n}\nimg[data-v-013e7a48] { \n    height: 500px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-013e7a48","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/misc/Contact.vue
// module id = 69
// module chunks = 0